(() => {
  function imageKey(image) {
    try {
      const url = new URL(image.currentSrc || image.getAttribute('src'), location.href);
      return decodeURIComponent(url.pathname).replace(/_(?:\d+x\d*|small|medium|large|grande)(?=\.)/g, '');
    } catch { return ''; }
  }
  function prepare(root = document) {
    root.querySelectorAll('[data-product-summary]').forEach(summary => {
      summary.querySelectorAll('img, video, iframe, picture, figure').forEach(media => media.remove());
      summary.querySelectorAll('p, div, section, a').forEach(element => {
        if (!element.textContent.trim() && !element.querySelector('button, input')) element.remove();
      });
      summary.querySelectorAll('h2').forEach(heading => {
        if (heading.textContent.trim() === 'Product details') heading.remove();
      });
    });
    root.querySelectorAll('[data-product-content]').forEach(content => {
      if (content.dataset.layoutPrepared) return;
      content.dataset.layoutPrepared = 'true';
      const description = content.querySelector('[data-detail-description]');
      const embedded = [...description.querySelectorAll('img, video, iframe')];
      const seen = new Set();
      if (embedded.length) {
        const fragment = document.createDocumentFragment();
        embedded.forEach(media => {
          const key = media.tagName === 'IMG' ? imageKey(media) : media.getAttribute('src');
          if (key && seen.has(key)) return;
          if (key) seen.add(key);
          const wrapper = document.createElement('div');
          wrapper.className = 'cgl-product-content__media';
          if (media.tagName === 'IMG') {
            media.loading = 'lazy';
            media.style.cssText = 'display:block;width:100%;height:auto;max-width:100%;';
          }
          wrapper.append(media);
          fragment.append(wrapper);
        });
        description.replaceChildren(fragment);
      } else {
        // The text is already visible next to the purchase controls.
        description.hidden = true;
      }
      content.querySelectorAll('[data-detail-media]').forEach(wrapper => {
        const image = wrapper.querySelector('img');
        if (!image) return;
        const key = imageKey(image);
        if (key && seen.has(key)) wrapper.hidden = true;
        else if (key) seen.add(key);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare());
  else prepare();
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
